import { gql } from '@apollo/client/core';

export const GET_AI_VOICES = gql`
  query GetAiVoices(
    $limit: Int!
    $offset: Int!
    $sortOrder: String!
    $provider: String
    $isActive: Boolean
    $isPremium: Boolean
    $gender: String
    $language: String
    $search: String
    $sortBy: String
  ) {
    aiVoices(
      limit: $limit
      offset: $offset
      sortOrder: $sortOrder
      provider: $provider
      isActive: $isActive
      isPremium: $isPremium
      gender: $gender
      language: $language
      search: $search
      sortBy: $sortBy
    ) {
      aiVoices {
        voiceId
        providerVoiceId
        name
        displayName
        provider
        gender
        accent
        language
        sampleAudioUrl
        isActive
        isPremium
        isDefault
        useCase
      }
      total
      hasMore
    }
  }
`;
